
import axios from "axios";
// import { redirectLogin } from "./index";
import { message } from "ant-design-vue";
import router from "@/routes";

const config = {
	baseURL: process.env.VUE_APP_API_URL,
	timeout: 60 * 1000, // Timeout
};

const _axios = axios.create(config);

_axios.defaults.retry = 0;
_axios.defaults.retryDelay = 1000;

_axios.interceptors.request.use((request) => {
	request.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
	return request;
});


_axios.interceptors.response.use(
	response => {
		return response.data;
	},
	error => {
		if (!error.response) {
			return Promise.reject(error);
		}
		const { response } = error;
		if (response.status === 401 && !["login", "register", "notPermission", "notFound"].includes(router.currentRoute.name)) {
			localStorage.clear();
			sessionStorage.clear();
			window.location.href = "/login";
		}
		return Promise.reject(error);
	},
);

export const get = ({ url, params }, respType = null, showToast = false) => {
	return new Promise((resolve, reject) => {
		_axios.get(url, {
			params,
			responseType: respType,
		}).then(res => {
			resolve(res);
		}).catch(err => {
			if (err && err.status === 200 && showToast) {
				message.error(err.data.retMsg);
			}
			reject(err);
		});
	});
};

export const put = ({ url, data, params }, showToast = false) => {
	return new Promise((resolve, reject) => {
		_axios.put(url, data, { params }).then(res => {
			resolve(res);
		}).catch(err => {
			if (err && err.status === 200 && showToast) {
				message.error(err.data.retMsg);
			}
			reject(err);
		});
	});
};

export const post = ({ url, data, params }, showToast = false) => {
	return new Promise((resolve, reject) => {
		_axios.post(url, data, { ...params }).then(res => {
			resolve(res);
		}).catch(err => {
			if (err && err.status === 200 && showToast) {
				message.error(err.data.retMsg);
			}
			reject(err);
		});
	});
};

export const postWithParams = ({ url, data, params }, showToast = false) => {
	return new Promise((resolve, reject) => {
		_axios.post(url, data, { params }).then(res => {
			resolve(res);
		}).catch(err => {
			if (err && err.status === 200 && showToast) {
				message.error(err.data.retMsg);
			}
			reject(err);
		});
	});
};

export const del = ({ url, data }, showToast = false) => {
	return new Promise((resolve, reject) => {
		_axios.delete(url, { data }).then(res => {
			resolve(res);
		}).catch(err => {
			if (err && err.status === 200 && showToast) {
				message.error(err.data.retMsg);
			}
			reject(err);
		});
	});
};

export const constructURL = function (urlPartial) {
	let { baseURL } = _axios.defaults;
	baseURL = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;
	urlPartial = urlPartial.startsWith("/") ? urlPartial.slice(1) : urlPartial;
	return `${baseURL}/${urlPartial}`;
};
